import { render } from "./ResetPasswordForm.vue?vue&type=template&id=fcccc786&scoped=true"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=js"

import "./ResetPasswordForm.vue?vue&type=style&index=0&id=fcccc786&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcccc786"]])

export default __exports__